"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { ArrowRight, PhoneCall, CircleCheck as CheckCircle2 } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Cta() {
  const shouldReduceMotion = useReducedMotion();
  const highlights = ["Representação exclusiva Spraying Systems Co.", "Apoio técnico e dimensionamento à medida", "Mais de 30 anos de experiência em Portugal"];
  return <section id="calltoaction" data-nav="light" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div initial={shouldReduceMotion ? {
        opacity: 1
      } : {
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.6,
        ease: "easeOut"
      }} className="relative overflow-hidden rounded-2xl bg-primary px-6 py-12 text-primary-foreground shadow-xl sm:px-12 md:py-16 lg:px-16">
          {/* Subtle decorative background graphic */}
          <div aria-hidden="true" className="pointer-events-none absolute -right-16 -top-16 h-80 w-80 rounded-full bg-secondary/20 blur-3xl" />
          <div aria-hidden="true" className="pointer-events-none absolute -bottom-20 -left-20 h-80 w-80 rounded-full bg-accent-foreground/10 blur-3xl" />

          <div className="relative z-10 grid grid-cols-1 items-center gap-10 lg:grid-cols-12 lg:gap-12">
            <div className="lg:col-span-7">
              <span className="inline-flex items-center gap-2 rounded-md bg-white/10 px-3 py-1 text-xs font-semibold uppercase tracking-wider text-primary-foreground/90 backdrop-blur-xs">
                <PhoneCall className="h-3.5 w-3.5" />
                Engenharia de Pulverização
              </span>
              <h2 className="mt-4 font-default text-3xl font-bold tracking-tight text-primary-foreground sm:text-4xl lg:text-5xl">
                Otimize os seus processos de pulverização industrial.
              </h2>
              <p className="mt-4 max-w-2xl text-base text-primary-foreground/85 sm:text-lg">
                Fale com os nossos especialistas técnicos e descubra a solução ideal para garantir máxima precisão, poupança de recursos e produtividade na sua unidade fabril.
              </p>

              <ul className="mt-6 flex flex-col gap-2.5 sm:gap-3">
                {highlights.map((item, i) => <li key={i} data-index={i} className="flex items-center gap-2.5 text-sm font-medium text-primary-foreground/90 sm:text-base">
                    <CheckCircle2 className="h-5 w-5 shrink-0 text-secondary" />
                    <span>{item}</span>
                  </li>)}
              </ul>
            </div>

            <div className="flex flex-col items-start gap-4 lg:col-span-5 lg:items-end">
              <div className="w-full rounded-xl border border-white/15 bg-white/5 p-6 backdrop-blur-xs sm:p-8 lg:max-w-md">
                <h3 className="font-default text-lg font-semibold text-primary-foreground sm:text-xl">
                  Pronto para analisar o seu projeto?
                </h3>
                <p className="mt-2 text-sm text-primary-foreground/80">
                  Apresente-nos as especificações do seu sistema e receba aconselhamento técnico dedicado.
                </p>
                <div className="mt-6">
                  <Button asChild size="lg" className="w-full bg-secondary font-medium text-secondary-foreground shadow-md transition-colors hover:bg-secondary/90">
                    <Link to="/ContactsPage" className="inline-flex w-full items-center justify-center gap-2">
                      <span>Contate-nos</span>
                      <ArrowRight className="h-4 w-4" />
                    </Link>
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}